import { TIME } from '../helpers/time';

export const HIT_TYPE = {
  EVENT: 'event',
};

export const EVENT_CATEGORIES = {
  AD: 'ad',
  BACKGROUND: 'background',
  BROWSE: 'browse',
  CM: 'cm',
  EXTERNAL: 'external',
  INTERACT: 'interact',
  LAUNCH: 'launch',
  PAIR: 'pair',
  QOS: 'qos',
  TEST: 'test',
  TOS: 'tos',
  WATCH: 'watch',
};

export const EVENT_NAMES = {
  // Browse
  VOD_EPISODE_PREVIEW: 'vodEpisodePreview',
  VOD_SERIES_PREVIEW: 'vodSeriesPreview',
  SESSION_RESET: 'sessionReset',
  VOD_EPISODE_WATCH: 'vodEpisodeWatch',
  SECTION_SELECT: 'sectionSelect',
  LINK_CLICK: 'linkClick',

  // Watch
  HEART_BEAT: 'heartBeat',
  EPISODE_START: 'episodeStart',
  EPISODE_END: 'episodeEnd',
  CLIP_START: 'clipStart',
  CLIP_END: 'clipEnd',

  // Interact
  CHANNEL_CHANGE: 'channelChange',
  AD_BUTTON: 'adButton',
  SCROLL_VERTICAL: 'scrollVertical',
  CLICK_VOLUME: 'clickVolume',
  CLICK_PLAY: 'clickPlay',
  CLICK_PAUSE: 'clickPause',

  // Background
  APP_LAUNCH: 'appLaunch',
  APP_LOADED: 'appLoaded',
  SIGN_IN: 'signInSuccessful',
  SIGN_OUT: 'signOutSuccessful',
  SIGN_UP: 'signUpSuccessful',
  UI_LOADED: 'uILoaded',
  VIDEO_BIT_RATE_CHANGE: 'videoBitRateChange',
  VIDEO_LOADED: 'videoLoaded',
  VIDEO_REQUEST: 'videoRequest',
  BOOTSTRAP_REQUEST: 'bootstrapRequest',
  BOOTSTRAP_LOADED: 'bootstrapLoaded',
  BOOTSTRAP_RESTART_REQUEST: 'bootstrapRestartRequest',
  CHANNEL_GUIDE_REQUEST: 'channelGuideRequest',
  CHANNEL_GUIDE_LOADED: 'channelGuideLoaded',

  // Pair
  PAIRING_CODE_INVALID: 'pairingCodeInvalid',
  PAIRING_ERROR: 'pairingError',
  PAIRING_REMOVED_SECONDARY: 'pairingRemovedSecondary',
  PAIRING_SUCCESS_SECONDARY: 'pairingSuccessSecondary',

  // QoS
  PLAYER_BUFFER_END: 'playerBufferEnd',
  PLAYER_BUFFER_START: 'playerBufferStart',
  APP_LAUNCH_TRACK: 'appLaunchTrack',
  VIDEO_ERROR: 'videoError',
  CHANNEL_ERROR: 'channelError',
  UNDEFINED_ERROR: 'undefinedError',

  // Cm
  CM_POD_BEGIN: 'cmPodBegin',
  CM_POD_END: 'cmPodEnd',
  CM_POD_START: 'cmPodStart',
  CM_POD_COMPLETE: 'cmPodComplete',
  CM_START: 'cmStart',
  CM_IMPRESSION: 'cmImpression',
  CM_FIRST_QUARTILE: 'cmFirstQuartile',
  CM_MID_POINT: 'cmMidPoint',
  CM_THIRD_QUARTILE: 'cmThirdQuartile',
  CM_COMPLETE: 'cmComplete',
  CM_BEGIN: 'cmBegin',
  CM_END: 'cmEnd',
  CM_ERROR: 'cmError',

  // TOS - Terms Of Service
  POLICY_ACCEPTED: 'policyAccepted',
  POLICY_VIEWED: 'policyViewed',
  POLICY_VIEWED_ACCEPTED: 'policyViewedAccepted',

  // MSN
  MUTE: 'mute',
  UNMUTE: 'unmute',
  ENTER_FULL_SCREEN: 'enterFullScreen',
  EXIT_FULL_SCREEN: 'exitFullScreen',
};

export const MSN_EVENTS_NAMES_MAPPING = {
  [EVENT_NAMES.VIDEO_LOADED]: 'Player Video Loaded',
  [EVENT_NAMES.CHANNEL_CHANGE]: 'Player Channel Change',
  [EVENT_NAMES.VIDEO_ERROR]: 'Video Error',
  [EVENT_NAMES.CM_ERROR]: 'Ad Error',
  [EVENT_NAMES.PLAYER_BUFFER_START]: 'Content Buffering',
  [EVENT_NAMES.EPISODE_START]: 'Video Start',
  [EVENT_NAMES.EPISODE_END]: 'Video End',
  [EVENT_NAMES.CM_POD_BEGIN]: 'Ad Start',
  [EVENT_NAMES.CM_POD_END]: 'Ad End',
  [EVENT_NAMES.ENTER_FULL_SCREEN]: 'Full Screen Enter',
  [EVENT_NAMES.EXIT_FULL_SCREEN]: 'Full Screen Exit',
  [EVENT_NAMES.HEART_BEAT]: 'Content Continue',
  [EVENT_NAMES.MUTE]: 'Video mute',
  [EVENT_NAMES.UNMUTE]: 'Video unmute',
};

export const TARGETS = {
  PLUTO: 'pluto',
  MSN: 'msn',
};

export const DEFAULT_TARGET = TARGETS.PLUTO;

export const POSTFIX_BEACON = '___BEACON';

export const SESSION_INACTIVITY_PERIOD = 30 * TIME.ONE_MIN_IN_MS;
